/** Formas de contato */
export interface ContatoForma {
    id: number;
    nome: string;
    iconClass: string;
}

export const CONTATO_FORMA_TELEFONE: ContatoForma = {
    id: 1,
    nome: 'Telefone',
    iconClass: 'fas fa-phone-alt'
};

export const CONTATO_FORMA_EMAIL: ContatoForma = {
    id: 2,
    nome: 'E-mail',
    iconClass: 'far fa-envelope'
};

export const CONTATO_FORMA_WHATSAPP: ContatoForma = {
    id: 3,
    nome: 'WhatsApp',
    iconClass: 'fab fa-whatsapp'
};

export const CONTATO_FORMA_LIKEDIN_MESSAGING: ContatoForma = {
    id: 4,
    nome: 'LinkedIn Messaging',
    iconClass: 'fab fa-linkedin'
};

export const CONTATO_FORMA_FACEBOOK_MESSENGER: ContatoForma = {
    id: 5,
    nome: 'Facebook Messenger',
    iconClass: 'fab fa-facebook-messenger'
};

export const CONTATO_FORMA_INSTAGRAM_DIRECT_MESSENGER: ContatoForma = {
    id: 6,
    nome: 'Instagram Direct Messenger',
    iconClass: 'fab fa-instagram'
};

export const CONTATO_FORMA_TELEGRAM: ContatoForma = {
    id: 7,
    nome: 'Telegram',
    iconClass: 'fab fa-telegram'
};

export const CONTATO_FORMA_VIDEOCONFERENCIA: ContatoForma = {
    id: 8,
    nome: 'Videoconferência',
    iconClass: 'fas fa-video'
};

export const CONTATO_FORMA_CONTATO_SITE: ContatoForma = {
    id: 9,
    nome: 'Contato Site',
    iconClass: 'fas fa-globe'
};

export const CONTATO_FORMA_OUTRA: ContatoForma = {
    id: 99,
    nome: 'Outra',
    iconClass: 'far fa-question-circle'
};


export const CONTATOS_FORMAS: ContatoForma[] = [
    CONTATO_FORMA_TELEFONE,
    CONTATO_FORMA_EMAIL,
    CONTATO_FORMA_WHATSAPP,
    CONTATO_FORMA_LIKEDIN_MESSAGING,
    CONTATO_FORMA_FACEBOOK_MESSENGER,
    CONTATO_FORMA_INSTAGRAM_DIRECT_MESSENGER,
    CONTATO_FORMA_TELEGRAM,
    CONTATO_FORMA_VIDEOCONFERENCIA,
    CONTATO_FORMA_CONTATO_SITE,
    CONTATO_FORMA_OUTRA,
];

/** Verifica se a forma do contato é telefone */
export function isContatoFormaTelefone(id: number): boolean {
    return id === CONTATO_FORMA_TELEFONE.id;
}

/** Verifica se a forma do contato é e-mail */
export function isContatoFormaEmail(id: number): boolean {
    return id === CONTATO_FORMA_EMAIL.id;
}

/** Verifica se a forma do contato é WhatsApp */
export function isContatoFormaWhatsApp(id: number): boolean {
    return id === CONTATO_FORMA_WHATSAPP.id;
}

/** Verifica se a forma do contato é LinkedIn Messaging */
export function isContatoFormaLinkedInMessaging(id: number): boolean {
    return id === CONTATO_FORMA_LIKEDIN_MESSAGING.id;
}

/** Verifica se a forma do contato é Facebook Messenger */
export function isContatoFormaFacebookMessenger(id: number): boolean {
    return id === CONTATO_FORMA_FACEBOOK_MESSENGER.id;
}

/** Verifica se a forma do contato é Instagram Direct Messenger */
export function isContatoFormaInstagramDirectMessenger(id: number): boolean {
    return id === CONTATO_FORMA_INSTAGRAM_DIRECT_MESSENGER.id;
}

/** Verifica se a forma do contato é Telegram */
export function isContatoFormaTelegram(id: number): boolean {
    return id === CONTATO_FORMA_TELEGRAM.id;
}

/** Verifica se a forma do contato é videoconferência */
export function isContatoFormaVideoconferencia(id: number): boolean {
    return id === CONTATO_FORMA_VIDEOCONFERENCIA.id;
}

/** Verifica se a forma do contato é contato site */
export function isContatoFormaContatoSite(id: number): boolean {
    return id === CONTATO_FORMA_CONTATO_SITE.id;
}

/** Verifica se a forma do contato é outra */
export function isContatoFormaOutra(id: number): boolean {
    return id === CONTATO_FORMA_OUTRA.id;
}
